import { render } from "./ZeroForm.vue?vue&type=template&id=7c992206"
import script from "./ZeroForm.vue?vue&type=script&lang=js"
export * from "./ZeroForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__